import { createFileRoute } from "@tanstack/react-router";
import TermsOfService from "@/pages/TermsOfService";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/condiciones-contratacion")({
  head: () => pageHead("terms", "es"),
  component: TermsOfService,
});
